
import Vue from 'vue';
import Router from 'vue-router';
import index from '@/views/mainIndex';
import examDetail from '@/views/examDetail';
import order from '@/views/order';

Vue.use(Router);

export default new Router({
  base: '/prebook/',
  mode: 'history',
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: "/examDetail",
      name: "examDetail",
      component: examDetail
    },
    {
      path: "/order",
      name: "order",
      component: order
    },
    {
      path: "*", // 访问页面路径不存在，重定向到首页
      redirect: "/index",
    },
  ]
});

// export default new Router({
//   base: '/prebook/',  // 保留基础路径（按需）
//   mode: 'history',
//   routes: [
//     {
//       path: '/prebook',       // 新增路径
//       name: 'prebook',
//       component: () => import('@/views/mainIndex'), // 替换为实际组件
//       meta: { title: '九斗' }
//     },
//     {
//       path: '/prebook/index', // 兼容性路径
//       name: 'prebookIndex',
//       component: index
//     },
//     // 其他原有路由...
//     {
//       path: '*',
//       redirect: '/prebook'    // 通配符重定向到/prebook而非/index
//     }
//   ]
// });



// export default [

//   {
//     path: "/index",
//     name: "index",
//     component: () => import("@/views/mainIndex"),
//     meta: {
//       title: "九斗"
//     }
//   },
//   {
//     path: "/order",
//     name: "order",
//     component: () => import("@/views/order"),
//     meta: {
//       title: "九斗"
//     }
//   },
//   {
//     path: "/examDetail",
//     name: "examDetail",
//     component: () => import("@/views/examDetail"),
//     meta: {
//       title: "九斗"
//     }
//   },
//   {
//     path: "*", // 访问页面路径不存在，重定向到首页
//     redirect: "/index",
//   },
// ];
